export enum MARKETPLACE_ROUTES {
  ROOT = "marketplace",
  DETAIL = ":addonTypeId",
  USE = ":addonTypeId/use",
  PARTNER = "partner/:partnerId",
}

export const BEST_SELLER_LIMIT = 6;

export const PURCHASED_CATEGORY_ID = "my_tools";
